module.exports = __webpack_public_path__ + "img/hr-pipe-straight-vertical-single.621a1245.png";